import { useParams } from 'react-router-dom';
import { useCallback, useMemo, useState } from 'react';
import { useCountryMapping } from 'hooks/useCountryMapping';
import { SupplierSpecialRate } from 'feature/supplierTabs/shipping/shippingRates/index';
import { useCountryAllWarehouseListQuery, useSupplierShippingRatesReadQuery } from 'api';

export const useSpecialRates: any = () => {
  const [openModal, setOpenModal] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [dataToEdit, setDataToEdit] = useState<SupplierSpecialRate | undefined>();
  const { countryMapping } = useCountryMapping();
  const { id } = useParams() as { id: string };
  const { data: warehouseData = [] } = useCountryAllWarehouseListQuery();
  const { data: specialRates = [] } = useSupplierShippingRatesReadQuery({ supplierId: id });

  const specialRatesData = useMemo(() => {
    const clonedSpecialRates = structuredClone(specialRates);
    return clonedSpecialRates.map((_item: any) => {
      const country = countryMapping[_item.countryId];
      if (country) {
        _item.countryName = country.commonName;
      }
      const warehouse = warehouseData.find((_warehouse: any) => _warehouse.id === _item.warehouseId);
      if (warehouse) {
        _item.warehouseName = warehouse.name;
      }

      return _item;
    });
  }, [countryMapping, specialRates, warehouseData]);

  const onHandleEdit = useCallback((data: SupplierSpecialRate) => {
    setDataToEdit(data);
    setOpenModal(true);
  }, []);
  const onHandleDelete = useCallback((data: SupplierSpecialRate) => {
    setDataToEdit(data);
    setIsDeleteModalOpen(true);
  }, []);
  const onDeleteModalClose = useCallback(() => {
    setIsDeleteModalOpen(false);
    setDataToEdit(undefined);
  }, []);
  const onModalStateChange = useCallback(() => {
    setOpenModal((oState) => {
      if (oState) {
        setDataToEdit(undefined);
      }
      return !oState;
    });
  }, []);

  return {
    openModal,
    specialRatesData,
    onModalStateChange,
    onHandleEdit,
    dataToEdit,
    onHandleDelete,
    isDeleteModalOpen,
    onDeleteModalClose,
  };
};
